(function () {
  'use strict';

  function initEcbPlayers(scope) {
    const root = scope || document;

    const players = root.querySelectorAll(
      '[data-ecb-player]:not([data-ecb-initialized="true"])'
    );

    players.forEach(function (player) {

      player.setAttribute('data-ecb-initialized', 'true');

      const defaultVideo = player.querySelector(
        '[data-ecb-video-default]'
      );

      const adVideo = player.querySelector(
        '[data-ecb-video-ad]'
      );

      const pauseBtn = player.querySelector(
        '[data-ecb-pause-toggle]'
      );

      const ccBtn = player.querySelector(
        '[data-ecb-cc-toggle]'
      );

      const adBtn = player.querySelector(
        '[data-ecb-ad-toggle]'
      );

      const transcriptBtn = player.querySelector(
        '[data-ecb-transcript-toggle]'
      );

      const transcriptDrawerId = transcriptBtn
        ? transcriptBtn.getAttribute('aria-controls')
        : null;

      const transcriptDrawer = transcriptDrawerId
        ? document.getElementById(transcriptDrawerId)
        : null;

      const transcriptCloseBtn = transcriptDrawer
        ? transcriptDrawer.querySelector(
            '[data-ecb-transcript-close]'
          )
        : null;

      const liveRegion = player.querySelector(
        '.ecb-live'
      );

      if (!defaultVideo || !pauseBtn) {
        return;
      }

      const shouldAutoplay =
        player.getAttribute('data-ecb-autoplay') === 'true';

      const pauseIcon =
        pauseBtn.querySelector('.ecb-icon-pause');

      const playIcon =
        pauseBtn.querySelector('.ecb-icon-play');

      const pauseTooltip =
        pauseBtn.querySelector('.ecb-tooltip');


      /* =========================================
         CURRENT VIDEO
         ========================================= */

      function getCurrentVideo() {
        return (
          adVideo &&
          adVideo.style.display !== 'none'
        )
          ? adVideo
          : defaultVideo;
      }


      /* =========================================
         CAPTION TRACK
         ========================================= */

      function getCaptionTrack(video) {
        if (!video) {
          return null;
        }

        const htmlTrack = video.querySelector(
          'track[kind="captions"], track[kind="subtitles"]'
        );

        return htmlTrack
          ? (htmlTrack.track || null)
          : null;
      }


      /* =========================================
         SCREEN READER ANNOUNCEMENT
         ========================================= */

      function announce(message) {

        if (!liveRegion || !message) {
          return;
        }

        liveRegion.setAttribute(
          'aria-live',
          'polite'
        );

        liveRegion.textContent = '';

        window.setTimeout(function () {

          liveRegion.textContent = message;

          window.setTimeout(function () {

            liveRegion.textContent = '';

            liveRegion.setAttribute(
              'aria-live',
              'off'
            );

          }, 800);

        }, 50);
      }


      /* =========================================
         PLAY / PAUSE BUTTON
         ========================================= */

      function updatePauseButton() {

        const activeVideo = getCurrentVideo();

        const isPaused = activeVideo.paused;

        pauseBtn.setAttribute(
          'aria-checked',
          isPaused ? 'false' : 'true'
        );

        pauseBtn.setAttribute(
          'aria-label',
          isPaused
            ? 'Play video'
            : 'Pause video'
        );

        if (pauseTooltip) {
          pauseTooltip.textContent =
            isPaused
              ? 'Play'
              : 'Pause';
        }

        if (pauseIcon) {
          pauseIcon.style.display =
            isPaused
              ? 'none'
              : 'block';
        }

        if (playIcon) {
          playIcon.style.display =
            isPaused
              ? 'block'
              : 'none';
        }
      }


      /* =========================================
         CAPTIONS
         ========================================= */

      function setCaptionsState(isOn) {

        [defaultVideo, adVideo].forEach(
          function (video) {

            if (!video) {
              return;
            }

            const track =
              getCaptionTrack(video);

            if (track) {

              track.mode = 'disabled';

              track.mode =
                isOn
                  ? 'showing'
                  : 'hidden';
            }

          }
        );

        if (ccBtn) {

          ccBtn.setAttribute(
            'aria-checked',
            isOn ? 'true' : 'false'
          );

          ccBtn.setAttribute(
            'aria-label',
            isOn
              ? 'Captions on'
              : 'Captions off'
          );
        }
      }


      function toggleCaptions() {

        const activeTrack =
          getCaptionTrack(
            getCurrentVideo()
          );

        if (!activeTrack) {

          announce(
            'No captions available'
          );

          return;
        }

        const nextState =
          activeTrack.mode !== 'showing';

        setCaptionsState(nextState);

        announce(
          nextState
            ? 'Captions on'
            : 'Captions off'
        );
      }


      /* =========================================
         AUDIO DESCRIPTION
         ========================================= */

      function setAdState(isOn) {

        if (!adVideo) {

          announce(
            'Audio description not available'
          );

          return;
        }

        const fromVideo =
          getCurrentVideo();

        const toVideo =
          isOn
            ? adVideo
            : defaultVideo;

        if (fromVideo === toVideo) {
          return;
        }

        const wasPaused =
          fromVideo.paused;

        const currentTime =
          fromVideo.currentTime || 0;

        const captionsWereOn =
          getCaptionTrack(fromVideo) &&
          getCaptionTrack(fromVideo).mode === 'showing';

        fromVideo.pause();

        fromVideo.style.display =
          'none';

        toVideo.style.display =
          'block';

        const syncAndPlay =
          function () {

            try {
              toVideo.currentTime =
                currentTime;
            } catch (e) {}

            const track =
              getCaptionTrack(toVideo);

            if (track) {

              track.mode =
                captionsWereOn
                  ? 'showing'
                  : 'hidden';
            }

            if (!wasPaused) {

              toVideo.play().catch(
                function () {}
              );
            }

            if (adBtn) {

              adBtn.setAttribute(
                'aria-checked',
                isOn
                  ? 'true'
                  : 'false'
              );

              adBtn.setAttribute(
                'aria-label',
                isOn
                  ? 'Audio description on'
                  : 'Audio description off'
              );
            }

            updatePauseButton();
          };

        if (toVideo.readyState >= 1) {

          syncAndPlay();

        } else {

          toVideo.load();

          toVideo.addEventListener(
            'loadedmetadata',
            syncAndPlay,
            { once: true }
          );
        }
      }


      function toggleAudioDescription() {

        if (!adVideo) {

          announce(
            'Audio description not available'
          );

          return;
        }

        const isAdOn =
          getCurrentVideo() === adVideo;

        const nextState =
          !isAdOn;

        setAdState(nextState);

        announce(
          nextState
            ? 'Audio description on'
            : 'Audio description off'
        );
      }


      /* =========================================
         PLAY / PAUSE
         ========================================= */

      function togglePlayPause() {

        const activeVideo =
          getCurrentVideo();

        if (activeVideo.paused) {

          activeVideo.currentTime = 0;

          activeVideo.muted = false;

          activeVideo.play().catch(
            function () {}
          );

        } else {

          activeVideo.pause();
        }

        updatePauseButton();
      }


      /* =========================================
         TRANSCRIPT
         ========================================= */

      function setTranscriptState(isOpen) {

        if (
          !transcriptDrawer ||
          !transcriptBtn
        ) {
          return;
        }

        transcriptDrawer.style.display =
          isOpen
            ? 'block'
            : 'none';

        transcriptBtn.setAttribute(
          'aria-expanded',
          isOpen
            ? 'true'
            : 'false'
        );

        transcriptBtn.setAttribute(
          'aria-label',
          isOpen
            ? 'Hide transcript'
            : 'Show transcript'
        );
      }


      function toggleTranscript() {

        if (!transcriptBtn) {
          return;
        }

        const isOpen =
          transcriptBtn.getAttribute(
            'aria-expanded'
          ) === 'true';

        setTranscriptState(
          !isOpen
        );
      }


      function closeTranscript() {

        setTranscriptState(false);

        if (transcriptBtn) {
          transcriptBtn.focus();
        }
      }


      /* =========================================
         EVENT LISTENERS
         ========================================= */

      pauseBtn.addEventListener(
        'click',
        togglePlayPause
      );

      if (ccBtn) {
        ccBtn.addEventListener(
          'click',
          toggleCaptions
        );
      }

      if (adBtn) {
        adBtn.addEventListener(
          'click',
          toggleAudioDescription
        );
      }

      if (transcriptBtn) {
        transcriptBtn.addEventListener(
          'click',
          toggleTranscript
        );
      }

      if (transcriptCloseBtn) {
        transcriptCloseBtn.addEventListener(
          'click',
          closeTranscript
        );
      }


      /* =========================================
         VIDEO EVENTS
         ========================================= */

      defaultVideo.addEventListener(
        'play',
        updatePauseButton
      );

      defaultVideo.addEventListener(
        'pause',
        updatePauseButton
      );

      defaultVideo.addEventListener(
        'ended',
        updatePauseButton
      );


      if (adVideo) {

        adVideo.addEventListener(
          'play',
          updatePauseButton
        );

        adVideo.addEventListener(
          'pause',
          updatePauseButton
        );

        adVideo.addEventListener(
          'ended',
          updatePauseButton
        );

        adVideo.style.display =
          'none';
      }


      /* =========================================
         INITIAL STATE
         ========================================= */

      defaultVideo.style.display =
        'block';

      setCaptionsState(false);

      setTranscriptState(false);

      defaultVideo.currentTime = 0;


      /* =========================================
         AUTOPLAY
         ========================================= */

      if (shouldAutoplay) {

        defaultVideo.muted = true;

        defaultVideo.play().catch(
          function () {}
        );
      }

      updatePauseButton();

    });
  }


  /* =========================================
     INITIAL LOAD
     ========================================= */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initEcbPlayers(document);
      }
    );

  } else {

    initEcbPlayers(document);
  }


  /* =========================================
     SHOPIFY SECTION LOAD
     ========================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initEcbPlayers(event.target);
    }
  );


  document.addEventListener(
    'shopify:section:select',
    function (event) {
      initEcbPlayers(event.target);
    }
  );


  /* =========================================
     SHOPIFY PRODUCT GALLERY / DYNAMIC DOM
     ========================================= */

  const observer =
    new MutationObserver(function (mutations) {

      mutations.forEach(function (mutation) {

        mutation.addedNodes.forEach(
          function (node) {

            if (
              node.nodeType !== 1
            ) {
              return;
            }

            if (
              node.matches &&
              node.matches(
                '[data-ecb-player]'
              )
            ) {
              initEcbPlayers(node);
            }

            if (
              node.querySelector
            ) {

              initEcbPlayers(node);
            }

          }
        );

      });

    });

  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

})();